/* globals $ Craft */

class ProviderWebsite {
  constructor() {}

  init($elem) {
    $.each($elem, (i, elem) => {
      $(elem)
        .find(".js-provider-website")
        .on("click", (e) => {
          this.handleClick($(e.currentTarget));
        });
    });
  }

  handleClick($email) {
    $.ajax({
      url: Craft.currentSite.baseUrl + "?action=swissmed-api/providers/website-click",
      method: "post",
      headers: {
        "X-CSRF-Token": Craft.csrfToken,
      },
      data: {
        websiteId: $email.data("websiteid"),
        providerId: $email.data("providerid"),
      },
    });
  }
}

export { ProviderWebsite };
